// extracted by mini-css-extract-plugin
module.exports = {"code":"oauth_code__1SsWf","container":"oauth_container__2qK2j","scopes-list":"oauth_scopes-list__1Y1ZL"};